module.exports = __webpack_public_path__ + "img/logo2.4ea3eb29.png";